import { render, staticRenderFns } from "./RelatedProduct.vue?vue&type=template&id=00976cf0&scoped=true&"
import script from "./RelatedProduct.vue?vue&type=script&lang=js&"
export * from "./RelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProduct.vue?vue&type=style&index=0&id=00976cf0&lang=less&scoped=true&"
import style1 from "./RelatedProduct.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00976cf0",
  null
  
)

export default component.exports